module.exports = __webpack_public_path__ + "img/knsu_gallery0.4e989016.jpg";